import React, { Component } from 'react';
import { connect } from 'react-redux';
import { goBack } from 'connected-react-router';
import CloseButton from '../components/close-button';

class HelpPage extends Component {

    constructor( props ){
        super( props );

        this._goBackAPage = this._goBackAPage.bind(this);
    }

    _goBackAPage() {
        const { goBackAPage } = this.props;
        goBackAPage();
    }

    render() {
        return(
            <div className="help-page">
                <CloseButton />
                <div className="help-page-info">
                    <div className="help-page-info-col">
                        <h2>Lorem ipsum</h2>
                        <p>dolor sit amet, consectetur adipiscing elit. Donec posuere ex sed malesuada vulputate. Vivamus suscipit maximus quam, id condimentum lacus maximus nec.</p>
                        <p>Quisque et molestie orci. Suspendisse ligula magna, faucibus interdum urna suscipit, accumsan interdum justo. Integer in rutrum leo. Nam aliquet aliquet ornare.</p>
                        <p> Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Quisque commodo tellus in ligula mollis malesuada. Nullam quis tellus non velit convallis aliquet vitae sit amet nunc. Donec convallis leo quam, porta dapibus leo congue vel. </p>
                    </div>
                    <div className="help-page-info-col">
                        <h2>Integer ex dui</h2>
                        <p>tempus a blandit at, pulvinar vel turpis. Quisque pulvinar id ipsum ut pharetra. Suspendisse eros ipsum, feugiat eu dolor eu, posuere suscipit eros.</p>
                        <p>Praesent sed malesuada arcu, eget viverra nisl. Etiam eu rutrum mi, sed facilisis turpis. Nam non blandit augue. </p>
                    </div>
                </div>
            </div>
        );
    }

}

const mapDispatchToProps = ( dispatch ) => {
    return {
        goBackAPage: () => {
            dispatch( goBack() );
        }
    }
};

export default connect(null,mapDispatchToProps)(HelpPage);


// WEBPACK FOOTER //
// ./src/pages/help.js